<template>
    <div v-if="cartCount()">
        <CartSummary></CartSummary>
        <div v-if="cartCount()" class="row align-items-center">
            <div class="col col-md-4">
                <router-link :to="{name: 'homepage'}" class="main-btn">
                    {{ capitalize($t('cart_continue_with_buying')) }}
                </router-link>
            </div>
            <div class="col col-md-4 ml-md-auto">
                <button dusk="cart-next-step" type="submit" class="next-step btn btn-purple w-100" :class="{'disabled': nextStepDisabled()}" @click="validate()">
                    {{ $t('btn_bill') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import CartSummary from './CartSummary.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'CartButtons',
    components: {
         CartSummary,
    },
    props: {
    },
    methods: {

        ...mapGetters('cart', [
            'cartCount',
        ]),

        validate() {
            this.$router.push({name : "billing"})
        },

        nextStepDisabled() {
            if(!this.cartCount()) {
                return true;
            }

            return false;
        }
    }
}
</script>
<style lang="scss" scoped>
    .disabled{
        background-color: #9EABED;
        border-radius: 4px;
        &:hover{
            cursor: not-allowed;
        }
    }
</style>
